/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs'
import * as FeedDefs from '../feed/defs.defs'
import * as GraphDefs from '../graph/defs.defs'
import * as LabelerDefs from '../labeler/defs.defs'
import * as ActorDefs from '../actor/defs.defs'
import * as EmbedImages from './images.defs'
import * as EmbedVideo from './video.defs'
import * as EmbedGallery from './gallery.defs'
import * as EmbedExternal from './external.defs'
import * as EmbedRecordWithMedia from './recordWithMedia.defs'
import * as LabelDefs from '../../../com/atproto/label/defs.defs'

const $nsid = 'app.bsky.embed.record'

type $nsid = typeof $nsid

export { $nsid }

type Main = { $type?: 'app.bsky.embed.record'; record: RepoStrongRef.Main }

export type { Main }

const main = /*#__PURE__*/ l.typedObject<Main>(
  $nsid,
  'main',
  /*#__PURE__*/ l.object({
    record: /*#__PURE__*/ l.ref<RepoStrongRef.Main>(
      (() => RepoStrongRef.main) as any,
    ),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type View = {
  $type?: 'app.bsky.embed.record#view'
  record:
    | l.$Typed<ViewRecord>
    | l.$Typed<ViewNotFound>
    | l.$Typed<ViewBlocked>
    | l.$Typed<ViewDetached>
    | l.$Typed<FeedDefs.GeneratorView>
    | l.$Typed<GraphDefs.ListView>
    | l.$Typed<LabelerDefs.LabelerView>
    | l.$Typed<GraphDefs.StarterPackViewBasic>
    | l.Unknown$TypedObject
}

export type { View }

const view = /*#__PURE__*/ l.typedObject<View>(
  $nsid,
  'view',
  /*#__PURE__*/ l.object({
    record: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<ViewRecord>((() => viewRecord) as any),
        /*#__PURE__*/ l.typedRef<ViewNotFound>((() => viewNotFound) as any),
        /*#__PURE__*/ l.typedRef<ViewBlocked>((() => viewBlocked) as any),
        /*#__PURE__*/ l.typedRef<ViewDetached>((() => viewDetached) as any),
        /*#__PURE__*/ l.typedRef<FeedDefs.GeneratorView>(
          (() => FeedDefs.generatorView) as any,
        ),
        /*#__PURE__*/ l.typedRef<GraphDefs.ListView>(
          (() => GraphDefs.listView) as any,
        ),
        /*#__PURE__*/ l.typedRef<LabelerDefs.LabelerView>(
          (() => LabelerDefs.labelerView) as any,
        ),
        /*#__PURE__*/ l.typedRef<GraphDefs.StarterPackViewBasic>(
          (() => GraphDefs.starterPackViewBasic) as any,
        ),
      ],
      false,
    ),
  }),
)

export { view }

type ViewRecord = {
  $type?: 'app.bsky.embed.record#viewRecord'
  cid: l.CidString
  uri: l.AtUriString

  /**
   * The record data itself.
   */
  value: l.LexMap
  author: ActorDefs.ProfileViewBasic
  embeds?: (
    | l.$Typed<EmbedImages.View>
    | l.$Typed<EmbedVideo.View>
    | l.$Typed<EmbedGallery.View>
    | l.$Typed<EmbedExternal.View>
    | l.$Typed<View>
    | l.$Typed<EmbedRecordWithMedia.View>
    | l.Unknown$TypedObject
  )[]
  labels?: LabelDefs.Label[]
  indexedAt: l.DatetimeString
  likeCount?: number
  quoteCount?: number
  replyCount?: number
  repostCount?: number
}

export type { ViewRecord }

const viewRecord = /*#__PURE__*/ l.typedObject<ViewRecord>(
  $nsid,
  'viewRecord',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    value: /*#__PURE__*/ l.lexMap(),
    author: /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
      (() => ActorDefs.profileViewBasic) as any,
    ),
    embeds: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.typedUnion(
          [
            /*#__PURE__*/ l.typedRef<EmbedImages.View>(
              (() => EmbedImages.view) as any,
            ),
            /*#__PURE__*/ l.typedRef<EmbedVideo.View>(
              (() => EmbedVideo.view) as any,
            ),
            /*#__PURE__*/ l.typedRef<EmbedGallery.View>(
              (() => EmbedGallery.view) as any,
            ),
            /*#__PURE__*/ l.typedRef<EmbedExternal.View>(
              (() => EmbedExternal.view) as any,
            ),
            /*#__PURE__*/ l.typedRef<View>((() => view) as any),
            /*#__PURE__*/ l.typedRef<EmbedRecordWithMedia.View>(
              (() => EmbedRecordWithMedia.view) as any,
            ),
          ],
          false,
        ),
      ),
    ),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
      ),
    ),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    likeCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    quoteCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    replyCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    repostCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  }),
)

export { viewRecord }

type ViewBlocked = {
  $type?: 'app.bsky.embed.record#viewBlocked'
  uri: l.AtUriString
  author: FeedDefs.BlockedAuthor
  blocked: true
}

export type { ViewBlocked }

const viewBlocked = /*#__PURE__*/ l.typedObject<ViewBlocked>(
  $nsid,
  'viewBlocked',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    author: /*#__PURE__*/ l.ref<FeedDefs.BlockedAuthor>(
      (() => FeedDefs.blockedAuthor) as any,
    ),
    blocked: /*#__PURE__*/ l.literal(true),
  }),
)

export { viewBlocked }

type ViewDetached = {
  $type?: 'app.bsky.embed.record#viewDetached'
  uri: l.AtUriString
  detached: true
}

export type { ViewDetached }

const viewDetached = /*#__PURE__*/ l.typedObject<ViewDetached>(
  $nsid,
  'viewDetached',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    detached: /*#__PURE__*/ l.literal(true),
  }),
)

export { viewDetached }

type ViewNotFound = {
  $type?: 'app.bsky.embed.record#viewNotFound'
  uri: l.AtUriString
  notFound: true
}

export type { ViewNotFound }

const viewNotFound = /*#__PURE__*/ l.typedObject<ViewNotFound>(
  $nsid,
  'viewNotFound',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    notFound: /*#__PURE__*/ l.literal(true),
  }),
)

export { viewNotFound }
